module.exports = __webpack_public_path__ + "img/Icon-Save.5d67985b.svg";